import { AuthError } from '@supabase/supabase-js';

export function localizeAuthError(error: unknown): string {
  if (error instanceof AuthError) {
    const message = error.message.toLowerCase();
    const code = (error.code ?? '').toLowerCase();
    const status = String(error.status ?? '');

    if (
      status === '429' ||
      code.includes('over_email_send_rate_limit') ||
      message.includes('over_email_send_rate_limit') ||
      message.includes('email rate limit') ||
      message.includes('for security purposes') ||
      message.includes('only request this after')
    ) {
      return 'Sačekajte 60 sekundi pre novog zahteva za email.';
    }
    if (code === 'email_not_confirmed' || message.includes('email not confirmed')) {
      return 'Potvrdite email pre prijave.';
    }
    if (
      code === 'invalid_credentials' ||
      message.includes('invalid login credentials') ||
      message.includes('invalid credentials')
    ) {
      return 'Neispravan email ili lozinka.';
    }
    if (
      message.includes('code verifier not found') ||
      message.includes('pkce code verifier')
    ) {
      return 'Link mora da se otvori u istom pregledaču u kome ste započeli registraciju. Otvorite email u tom pregledaču, ili se prijavite ovde ako je nalog već potvrđen.';
    }

    switch (error.message) {
      case 'Not signed in':
        return 'Niste prijavljeni';
      case 'Profile not found':
        return 'Profil nije pronađen';
      default:
        return error.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string' && message.length > 0) {
      const code =
        'code' in error && typeof (error as { code: unknown }).code === 'string'
          ? (error as { code: string }).code
          : '';
      const lower = message.toLowerCase();
      if (code === 'PGRST116' || lower.includes('0 rows')) {
        return 'Profil nije pronađen. Odjavite se i registrujte se ponovo, ili prvo potvrdite email.';
      }
      if (
        lower.includes('code verifier not found') ||
        lower.includes('pkce code verifier')
      ) {
        return 'Link mora da se otvori u istom pregledaču u kome ste započeli registraciju. Otvorite email u tom pregledaču, ili se prijavite ovde ako je nalog već potvrđen.';
      }
      return message;
    }
  }

  return String(error);
}
